module.exports = __webpack_public_path__ + "img/desafios-varita.a6446d59.svg";